import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

/** Shown in Custom View when the class has no students (no seats / layout controls). */
export function SeatPlanEmptyState(): JSX.Element {
	const { t } = useTranslation();
	return (
		<Flex align="center" justify="center" minH="240px" px={6} data-testid="seatplan-empty-state">
			<Text color="gray.600" fontSize="md" fontWeight="medium" textAlign="center">
				{t("seatPlan.addStudentsPrompt")}
			</Text>
		</Flex>
	);
}
